import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { TaxonomyService } from "../../services/TaxonomyService";
import { MULTI, Selector } from "../Selectors/Selector";

export const TaxonomySelect = ({
  taxonomyId,
  selectHandler,
  clear,
  size,
  needLabel,
}) => {
  const { t } = useTranslation();
  const [taxonomyLevels, setTaxonomyLevels] = useState([]);

  useEffect(() => {
    TaxonomyService.getAllTaxonomies(taxonomyId).then((taxonomies) => {
      const objectives = [];
      for (const taxonomy of taxonomies) {
        const taxLevels = Object.values(taxonomy.objectives);
        taxLevels.sort((a, b) => a.sequence - b.sequence);
        objectives.push(...taxLevels);
      }

      setTaxonomyLevels(
        objectives.map((level) => {
          if (needLabel) {
            return { id: level.title, label: level.title };
          } else {
            return { id: level.id, label: level.title };
          }
        })
      );
    });
  }, [taxonomyId]);

  return (
    <Selector
      type={MULTI}
      id="taxonomy-level-select"
      label={t("analyze.taxonomy.levelTitle")}
      assistiveText={t("analyze.taxonomy.assistiveText")}
      options={taxonomyLevels}
      selectHandler={selectHandler}
      clear={clear}
      size={size}
    />
  );
};
